import React, { useState } from 'react';
import classes from "./CategoryPage.module.css";
import styles from './SubscriptionPage.module.css';
import CategoriesSection from '../components/CategoriesSection';
import Lottie from 'lottie-react';
import stars from "../animations/stars3.json";
import { Link, useSearchParams } from "react-router";
import { toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from "uuid";
import { loginApi } from '../http/http';
import Cookies  from 'js-cookie';
import LanguageSelector from './LanguageSelector';
import { useContext } from "react";
import { LanguageContext } from "./LanguageContext";
import TopHeroWithImage from './TopHeroWithImage';
import Terms from '../components/Terms';



const LoginPage = () => {
  const [msisdn, setMsisdn] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
 const { lang } = useContext(LanguageContext);

  const handleSubscribe = async (e) => {
    e.preventDefault();

    if (!msisdn) {
      toast.error("Please enter your mobile number");
      return;
    }
   try {
  setLoading(true);
  const res = await loginApi(msisdn);
console.log(res,"responseLoginAPI");
 if (res?.data?.is_subscribed == true) {
    toast.success(res.data?.msg);
    Cookies.set("user_msisdn", msisdn, { expires: 1 });
    Cookies.set("user_id",res?.data?.user_id, {expires:1});
    navigate('/home');
    // setTimeout(() => navigate('/home'), 2000);
  }

} catch (error) {
  setLoading(false);
  console.error("API error:", error);

  if (error.res.is_subscribed == false) {
    toast.error(error.res?.data?.msg || "User not subscribed");
  } else {
    toast.error("Something went wrong. Please try again!");
  }
}

  };

  return (
    <>
      
       

      <div className={styles.container}>
         <LanguageSelector />
        <div className={styles.topImageWrapper}>
              <img
                src={
                  lang === "eng"
                    ? "/assets/images/loginpageeng.png"
                    : "/assets/images/loginpagearabic.png"
                }
                alt="kids"
                className={styles.topImage}
              />
            </div>

        { <Lottie
          animationData={stars}
          loop={true}
          autoplay={true}
          initialSegment={[0, 100]}
          className={classes.background_animation}
        /> }
        <div className={styles.card}>
          <h1 className={styles.title}>{lang =="eng" ? 'Fill Your Mobile Number':'أدخل رقم هاتفك المحمول'}</h1>
          {/* <p className={styles.desc}>{lang=="eng" ? "Get fun educational content delivered via Mobily subscription.":"احصل على محتوى تعليمي ممتع عبر اشتراك موبايلي."}</p> */}

          <form onSubmit={handleSubscribe} className={styles.form}>
            {/* <label className={styles.label}>{lang=="eng" ? "Mobile Number" : "رقم الهاتف المحمول"}</label> */}
            <input
              className={styles.input}
              value={msisdn}
              onChange={(e) => setMsisdn(e.target.value)}
             placeholder="9665XXXXXXXX"
              inputMode="tel"
            />
            <button
              className={styles.button}
              type="submit"
              disabled={loading}
            >
              {loading ? (lang =="ar" ? "انتظر من فضلك..." : "Please wait..." ):(lang=="ar" ? "تسجيل الدخول" :"Login")}
            </button>
            <Link className={styles.formLink} to="/">{lang =="ar" ? "ليس مستخدمًا، اشترك":"Not a user, Subscribe"}</Link>
          </form>
        </div>
      </div>
      <Terms />
    </>
  );
}

export default LoginPage;
